export default {
  buttonStyle: {
    width: 85,
    padding: 0,
    textAlign: 'center',
    fontFamily: 'roboto-regular',
  },
};

export const projectCardDimensions = { width: 285, height: 197 };

export const FOOTER_HEIGHT = 53;
export const HEADER_HEIGHT = 55;
export const TABS_NAVIGATION_HEIGHT = 46;
